import React from 'react';
import { IconButton, Tooltip } from "@mui/material";
import MUIDataTable from 'mui-datatables';
import { Localizacion } from 'lib.front';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AbonosEstadoChip } from './AbonosEstadoChip';
import { formatFecha } from '../../utils/constans/formatFecha';

const options = {
    filter: false,
    selectableRows: 'none',
    expandableRowsHeader: false,
    pagination: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    search: true,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: false,
    selectToolbarPlacement: 'none',
    selectableRowsOnClick: false,
    textLabels: Localizacion.muiDataTables.ES
};

const AbonosTable = ({
    data,
    verDetalles
}) => {


    const column = [
        {
            name: 'idPago',
            label: '',
            options: {
                sort: false,
                display: false
            }
        },
        {
            name: 'docIdentidadCliente',
            label: 'RUC/DNI',
            options: {
                sort: true,
                display: true
            }
        },
        {
            name: 'nombreRazonSocialCliente',
            label: 'Cliente',
            options: {
                sort: true,
                display: true
            }
        },
        {
            name: 'documento',
            label: 'Documento',
            options: {
                sort: true,
                display: true,
            }
        },
        {
            name: 'monto',
            label: 'Monto',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value.toFixed(2)
                }
            }
        },
        {
            name: 'fechaPago',
            label: 'Fecha Pago',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return formatFecha(value)
                }
            }
        },
        {
            name: 'fechaCobro',
            label: 'Fecha Cobro',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return formatFecha(value)
                }
            }
        },
        {
            name: 'estadoPago',
            label: 'Estado',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <AbonosEstadoChip estado={value} />;

                }
            }
        },
        {
            name: '',
            label: 'Detalles',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Tooltip title="Ver detalles">
                            <IconButton
                                onClick={() => verDetalles(tableMeta.rowData[0])}
                                size="large"
                            >
                                <VisibilityIcon />
                            </IconButton>
                        </Tooltip>
                    );
                }
            }
        }
    ];

    return (
        <MUIDataTable
            options={options}
            columns={column}
            data={data}
        />
    );
};
export default AbonosTable